/*
 * Copyright (c) 2020 DV Bern AG, Switzerland
 *
 * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich
 * geschuetzt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulaessig. Dies gilt
 * insbesondere fuer Vervielfaeltigungen, die Einspeicherung und Verarbeitung in
 * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur
 * Ansicht uebergeben ist jede weitere Verteilung durch den Kunden an Dritte untersagt.
 *
 */

import * as angular from 'angular';
import 'angular-smart-table';
import {SerfWebCore} from '../core/core.module';
import './cockpit.module.scss';

import {cockpitRun} from './cockpit.route';
import {CockpitViewComponentConfig} from './component/cockpitView';

export const SerfWebCockpit = angular.module('serfWeb.cockpit', [SerfWebCore.name])
    .component('cockpitView', new CockpitViewComponentConfig())
    .run(cockpitRun);

export default SerfWebCockpit;



// WEBPACK FOOTER //
// ./src/app/cockpit/cockpit.module.ts